import React from 'react';
import { testimonials } from '../data/mock';
import { Star, MapPin } from 'lucide-react';

const Testimonials = () => {
  return (
    <section id="testimonials" className="section-padding" style={{ background: 'var(--bg-page)' }}>
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="heading-1 mb-4">Patient Success Stories</h2>
          <p className="body-large mx-auto" style={{ maxWidth: '700px', color: 'var(--text-secondary)' }}>
            Real experiences from patients who trusted us with their healthcare journey
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((testimonial) => (
            <div 
              key={testimonial.id} 
              className={`voice-card ${testimonial.colorClass}`}
            >
              <div className="flex items-center justify-between mb-4">
                <div>
                  <h4 className="heading-3">{testimonial.name}</h4>
                  <div className="flex items-center gap-1 mt-1">
                    <MapPin size={14} style={{ color: 'var(--text-muted)' }} />
                    <span className="caption" style={{ color: 'var(--text-muted)' }}>
                      {testimonial.country}
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-1">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} size={16} fill="var(--text-primary)" style={{ color: 'var(--text-primary)' }} />
                  ))}
                </div>
              </div>

              <div className="mb-3">
                <span 
                  className="caption px-3 py-1 rounded-full"
                  style={{ 
                    background: 'rgba(255, 255, 255, 0.5)',
                    border: '1px solid rgba(0, 0, 0, 0.1)'
                  }}
                >
                  {testimonial.procedure}
                </span>
              </div>

              <p className="body-small" style={{ color: 'var(--text-secondary)', fontStyle: 'italic' }}>
                "{testimonial.comment}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;